module.exports = __webpack_public_path__ + "static/slider_2a-b5541e789e13ddff963fda4cabd054cb.jpg";